import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Header } from '../../header';
import { useNavigate } from 'react-router-dom';

export const ProductsListPage = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://api.alyonatestsite.store/api/products');
      setProducts(response.data);
    } catch (error) {
      console.error('Ошибка загрузки товаров:', error);
    }
  };

  const handleDeleteProduct = async (id) => {
    try {
      await axios.delete(`https://api.alyonatestsite.store/api/products/${id}`);
      fetchProducts();
    } catch (error) {
      console.error('Ошибка удаления товара:', error);
    }
  };

  return (
<section className="min-h-screen bg-white">
  <Header fixed={false} />
  <div className='p-8'>
  <div className='flex flex-row space-x-4 items-center mb-6'>
          <button className='py-2 px-6 bg-blue-500 text-white w-fit rounded'
            onClick={() => navigate('/dashboard')}>
            Назад в ПУ
          </button> 
          <h1 className="text-3xl font-bold">Управление товарами</h1>
        </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {products.map((product) => (
        <div
          key={product._id}
          className="relative border rounded p-4 shadow-md flex flex-col h-full"
        >
          <div className="absolute top-8 right-8">
            {product.sizes.length > 0 ? (
              product.sizes.map((size) => (
                <p
                  key={size.name}
                  className={`text-right ${size.quantity <= 0 ? 'text-red-600 underline' : 'text-gray-700'}`}
                >
                  {size.quantity <= 0 && '(НВН)'} {size.name}: {size.quantity} шт.
                </p>
              ))
            ) : (
              <p
                className={`text-right ${
                  product.stock <= 0 ? 'text-red-600 underline' : 'text-gray-700'
                }`}
              >
                {product.stock} шт. {product.stock <= 0 && '(НВН)'}
              </p>
            )}
          </div>

          <img
            src={`https://api.alyonatestsite.store${product.images[0]}`}
            alt={product.name}
            className="w-24 h-24 mb-3 object-cover transition-transform duration-300 rounded-xl group-hover:shadow-2xl"
          />
          <h2 className="font-semibold text-lg font-lack">{product.name}</h2>
          <p>Артикул: {product.sku}</p>
          <p>
            Цена:{' '}
            {product.discount ? (
              <>
                <a className="text-sky-500 font-bold">{product.discount} ₽</a>{' '}
                <a className="line-through">{product.price} ₽</a>
              </>
            ) : (
              `${product.price} ₽`
            )}
          </p>

          <div className="mt-auto flex flex-col space-y-1">
            <a
              href={`/dashboard/edit-product/?id=${product.id}`}
              className="bg-blue-500 text-white px-4 py-2 rounded inline-flex justify-center items-center"
            >
              Редактировать
            </a>
            <button
              onClick={() => handleDeleteProduct(product.id)}
              className="bg-red-500 text-white px-4 py-2 rounded"
            >
              Удалить
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

  
  );
};
